import * as R from 'ramda';
import GeneratedDocumentWatcher from './GeneratedDocumentWatcher';

// import {loaderService} from "../../../../../services";
// import {alerts} from "../../../../global";

export default function GenerateDocumentDialogController(
  $cookies,
  $rootScope,
  $scope,
  $q,
  ssDialogService,
  loaderService,
  alerts,
  pmDataService,
  reportsDataService,
) {
  const vm = this;
  const generatedDocumentWatcher = new GeneratedDocumentWatcher($rootScope, $cookies);

  vm.submitButtonText = 'Generate Document';

  vm.saveDocument = false;
  vm.renderFullDocument = true;
  vm.isDocumentIndeterminate = true;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleRunReport = _handleRunReport;
  vm.handleFullReport = _handleFullReport;
  vm.handleSelectReport = _handleSelectReport;
  vm.handleSectionChange = _handleSectionChange;
  vm.handleSelectSaveDocument = _handleSelectSaveDocument;

  vm.noneChecked = _noneChecked;
  vm.noneCheckedMessage = _noneCheckedMessage;

  vm.sections = _getSections();

  /** ************************************************
   * Event Handlers
   */

  function _handleCloseDialog() {
    _closeDialog();
  }

  function _handleRunReport() {
    console.log('_handleRunReport');
    const dfdSave = $q.defer();

    if ($scope.pmGenerateDocumentForm.$valid) {
      const reportSections = R.join(',',
        R.pluck(
          'reportSectionId',
          R.filter(
            R.allPass([
              R.propEq('isSelected', true),
              R.propEq('isActive', true)
            ]),
            vm.sections
          )
        ));

      alerts.info('Please Wait! Queueing report. It may take little longer than normal to get the report');
      loaderService.showViewLoader = true;
      const downloadCall = pmDataService.generateFullReport(
        {
          policyDocumentId: vm.document.policyDocumentId,
          name: vm.document.name,
          reportSection: reportSections,
          renderFullReport: vm.renderFullDocument,
          saveDocument: vm.saveDocument,
        }
      );

      downloadCall.then((downloadDocumentResponse) => {
        alerts.success('The Policy Document was generated successfully.');
        loaderService.showViewLoader = false;
        generatedDocumentWatcher.setDocumentComplete();
        reportsDataService.download(downloadDocumentResponse);
        generatedDocumentWatcher.checkDocumentComplete(1);
      });

      _handleCloseDialog();
      dfdSave.resolve();
    } else {
      dfdSave.reject();
    }
  }

  /** ************************************************
   * Private Functions
   */

  function _closeDialog() {
    ssDialogService.hide(ssDialogService.dialogs.pm.generateDocumentDialog);
  }

  function _handleFullReport() {
    R.forEach((section) => {
      section.isSelected = vm.renderFullDocument;
    }, vm.sections);
  }

  function _handleSelectReport() {
    const sectionsShown = R.filter(R.propEq('isActive', true), vm.sections);

    if (sectionsShown !== null) {
      const sectionsSelected = R.filter(
        R.propEq('isSelected', true),
        sectionsShown
      );

      if (sectionsSelected !== null) {
        vm.renderFullDocument = sectionsShown.length === sectionsSelected.length;
      }
    }
  }

  function _handleSelectSaveDocument() {
    if (vm.saveDocument === true) {
      vm.submitButtonText = 'Generate Document for Board Approval';
    } else {
      vm.submitButtonText = 'Generate Document';
    }
  }

  function _handleSectionChange() {
    let chkboxCtrls;
    vm.renderFullDocument = chkboxCtrls
      || chkboxCtrls.length === 0;
    // _SaveDocumentSelection(vm.renderFullDocument);
    // _noneChecked(form);
  }

  // Validation
  function _noneChecked() {
    const selected = R.filter(
      R.allPass([
        R.propEq('isSelected', true),
        R.propEq('isActive', true)
      ]),
      vm.sections
    );

    return R.isNil(selected) || selected.length === 0;
  }

  function _noneCheckedMessage(form) {
    let result = null;
    if (form) {
      const selected = angular.element('input:checked[name="renderReportSec"]');

      if (selected || selected.length === 0) {
        const ctrl = form.renderFullDocument;
        if (ctrl) {
          result = ctrl.$error;
        }
      }
    }
    return result;
  }

  /** ************************************************
   * Private Functions
   */

  function _getSections() {
    const items = [];
    vm.document.policyDocumentSections.forEach((section) => {
      const item = {
        title: section.title,
        reportSectionId: section.policyDocumentSectionId,
        isSelected: true,
        isActive: true,
        sortOrder: section.documentSortOrder,
      };
      items.push(item);
    });
    return items;
  }
}

GenerateDocumentDialogController.$inject = [
  '$cookies',
  '$rootScope',
  '$scope',
  '$q',
  'ssDialogService',
  'loaderService',
  'alerts',
  'pmDataService',
  'reportsDataService'
];
